<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Affectation au technicien</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <!--        <label class="mt-4 block text-gray-700">Envoyer au superviseur:</label>-->
        <select v-model="form.sent" class="mt-1 w-full form-select">
          <option :value="null"/>
          <!--          <option value="with">Envoyer et non envoyer</option>
                    <option value="only">Envoyer uniquement</option>-->
        </select>
      </search-filter>
      <div class="flex">
        <select-input v-model="selectedUser" :error="errors.selectedUser" class="pr-6 w-60" label="Techniciens">
          <option disabled></option>
          <option v-for="tech in techs" :key="tech.id" :value="tech.id" >{{tech.name}}</option>
        </select-input>
        <button class="btn-indigo py-2.5 mr-4 flex h-11 mt-7 items-center disabled:opacity-50" @click="sendSelection" :disabled="selectedItems.length === 0 || selectedUser == null">
          <div v-if="sending" class="btn-spinner mr-2" />
          <span>Affecter</span>&nbsp;
          <span class="hidden md:inline">la selection</span>
        </button>
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4"><input type="checkbox" class="form-checkbox h-5 w-5" v-model="selectAll" @change="select"></th>
          <th class="px-6 pt-6 pb-4">N° Order</th>
          <th class="px-6 pt-6 pb-4">IMEI</th>
          <th class="px-6 pt-6 pb-4">Modele</th>
          <th class="px-6 pt-6 pb-4">Operateur</th>
          <th class="px-6 pt-6 pb-4">Agence</th>
          <th class="px-6 pt-6 pb-4">Panne</th>
          <th class="px-6 pt-6 pb-4">Garantie</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Creation</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <div class="px-6 py-4 flex items-center focus:text-indigo-500">
              <input type="checkbox" class="form-checkbox h-5 w-5" :value="repair.id" v-model="selectedItems">
            </div>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('receptions.edit', repair.id)">
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.imei }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.model }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.operator }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.agency }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.malfunction }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.warranty }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.created_at }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </inertia-link>
          </td>
        </tr>
        <tr v-if="repairs.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No reception found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from "@/Shared/TextInput";
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo: {title: 'Affectation au technicien'},
  layout: Layout,
  components: {
    TextInput,
    Icon,
    SearchFilter,
    Pagination,
    LoadingButton,
    SelectInput
  },
  props: {
    errors: Object,
    repairs: Object,
    techs: Object,
    filters: Object,
  },
  data() {
    return {
      selectedItems: [],
      selectedUser: null,
      selectAll: false,
      sending: false,
      form: {
        search: this.filters.search,
        role: this.filters.role,
        sent: this.filters.sent,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('supervisor.list', Object.keys(query).length ? query : {remember: 'forget'}), {
          preserveScroll: true,
          preserveState: true,
        })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    select() {
      this.selectedItems = [];
      if (this.selectAll) {
        for (let i in this.repairs.data) {
          if (this.repairs.data.hasOwnProperty(i)) {
            this.selectedItems.push(this.repairs.data[i].id);
          }
        }
      }
    },
    sendSelection() {
      const data = new FormData()
      data.append('ids', this.selectedItems || [])
      data.append('user', this.selectedUser || '')
      this.$inertia.post(this.route('supervisor.assign'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
          this.selectedItems = []
        }
      })
    }
  },
}
</script>
